import {IUploadFileFormBaseValues, mapUploadResourceMetadata} from 'admin/resources';
import {emptyResourceMetadataLookupNames, IResourceMetadataLookupNames} from 'admin/resources/utils';

export const mapUploadResourceFile = (
  values: IUploadFileFormBaseValues,
  lookupNames: IResourceMetadataLookupNames = emptyResourceMetadataLookupNames()
) => {
  const data = new FormData();
  const metadata = mapUploadResourceMetadata(values, lookupNames);

  data.append('file', values.file);
  data.append('displayName', values.displayName);
  data.append('briefDescription', values.briefDescription);
  data.append('fileTypeId', values.fileType.toString());
  data.append('filePath', values.link ?? '');
  data.append('metadata', JSON.stringify(metadata));

  return data;
};
